import React from "react";
import Letop from "../allpages/Letop";

export default () => (
  <div>
    <div>
      <div className="table">
        <table>
          <tr>
            <th className="col bor-bot" />
            <th colSpan={2}>praesens</th>
          </tr>
          <tr>
            <th className="col">1e ev.</th>
            <td>sum</td>
            <td>possum</td>
          </tr>
          <tr>
            <th className="col">2e ev.</th>
            <td>es</td>
            <td>potes</td>
          </tr>
          <tr>
            <th className="col">3e ev.</th>
            <td>est</td>
            <td>potest</td>
          </tr>
          <tr>
            <th className="col">1e mv.</th>
            <td>sumus</td>
            <td>possumus</td>
          </tr>
          <tr>
            <th className="col">2e mv.</th>
            <td>estis</td>
            <td>potestis</td>
          </tr>
          <tr>
            <th className="col bor-bot">3e mv.</th>
            <td className="bor-bot">sunt</td>
            <td className="bor-bot">possunt</td>
          </tr>
          <tr>
            <th />
            <td>
              <em>ik ben</em>
            </td>
            <td>
              <em>ik kan</em>
            </td>
          </tr>
        </table>
      </div>

      <p>
        <Letop>
          Het rijtje van <b>posse</b> is eigenlijk hetzelfde als het rijtje van{" "}
          <b>esse</b>, maar dan met <b>pos-</b> of <b>pot-</b> ervoor.
        </Letop>
      </p>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/esse-posse-9.js